const prefix = '@errors';

export const SET_ERROR = `${prefix}/SET_ERROR`;
